import { ISessionModel } from '../model/SessionModel';

export const WsConnect =
    (sessionModel: ISessionModel): {type: string; sessionModel: ISessionModel} => ({ type: 'WS_CONNECT', sessionModel });
